import React from 'react'
import CarouselBox from '../components/CarouselBox.jsx'
import {Params} from './../params.jsx'
import {introduction} from './../introduction'
import SecondHead from './../components/SecondHead'
import bonich_1 from './../assets/images/IMG_bonichi_1.jpeg'
import bonich_2 from './../assets/images/IMG_bonichi_2.jpeg'
import bonich_3 from './../assets/images/IMG_bonichi_3.jpeg'


const images = [
    bonich_1, bonich_2, bonich_3]

function Makondo(props){
	return(
        <>
        <SecondHead lang = {props.lang} link = {props.link}/>


		<div id="about" className="container mt-2 bg2 mymarge">
		    <div className="row">
		        <div className="col text-center">
		            <h3>{Params(props.lang).brand}</h3>
		        </div>
		    </div>
    		<div className="row">
        		<div className="col-md-9 about-slide p-5 d-flex justify-content-center align-items-center">

            		<div className="mysize d-flex justify-content-center align-items-center">
    
                		<div className="owl-carousel owl-theme">
                		<CarouselBox img = {images}/>
                </div>
            </div>

            
            </div>
            <div className="col-md-3 d-flex flex-column justify-content-center border border-primary">
                <div className="h-50">
                 <script  async src="https://api-maps.yandex.ru/services/constructor/1.0/js/?um=constructor%3A299e07c670dd056ad587f37e50361a9aa8a4169db10fad5dedd82ae39794015a&amp;lang=en_FR&amp;scroll=true"></script>  
                </div>
            </div>
            </div>
            <div className="row ">
                <div className="col pt-5 pb-5 fs-3">
                    {introduction(props.lang)}
                    
                </div>
            </div>

        </div>
    </>


		)
}

export default Makondo;